import React, { useState } from 'react';
import { Button, TextInput, Stack, Title } from '@mantine/core';
import { NotificationData, notifications } from '@mantine/notifications';
import { useNavigate } from '~node_modules/react-router/dist';
import { peep_client } from '~src/api/peep';
import { JoinGroupOptions } from '~src/api/peep/groups';

interface JoinGroupProps {
  initialToken?: string | null;
}

export default function JoinGroup({ initialToken }: JoinGroupProps) {
  const [code, setCode] = useState<string>(initialToken || '');
  const [alias, setAlias] = useState<string>('');
  const navigate = useNavigate();

  const join_group = async () => {
    const opts: JoinGroupOptions = {
      token: code,
      user_alias: alias,
    };

    try {
      await peep_client.groups.joinGroup(opts);
      navigate('/feed');
    } catch (err) {
      console.log(err);
      const data: NotificationData = {
        position: 'top-center',
        message: 'Failed to join group! Is your code correct?',
        color: 'red',
      };
      notifications.show(data);
    }
  };
  return (
    <Stack align="stretch" justify="center">
      <Title ta="center" order={3}>
        Have a Invite? Join a group!
      </Title>
      <TextInput
        label="Invite Code"
        withAsterisk
        radius="md"
        value={code}
        onChange={(e) => {
          setCode(e.target.value);
        }}
      />
      <TextInput
        label="Alias"
        description="This is what you will show up as to other users in the group (and yourself)."
        withAsterisk
        radius="md"
        onChange={(e) => {
          setAlias(e.target.value);
        }}
      />
      <Button onClick={join_group} disabled={!code || !alias}>
        Join Group
      </Button>
    </Stack>
  );
}
